// app/components/Footer.tsx
"use client";

import Image from "next/image";
import { motion } from "framer-motion";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="relative bg-gray-900 text-slate-900">
      {/* ================= BACKGROUND SVG ================= */}
      <div className="absolute inset-0 -z-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 900"
          preserveAspectRatio="none"
          className="h-full w-full"
        >
          {/* Dark top strip */}
          <rect width="1440" height="120" fill="#111827" />


          {/* Whale body */}
          <path
            fill="#7EDBD3"
            d="
              M0,120
              C200,200 420,260 720,240
              C1000,220 1200,180 1440,200
              L1440,900
              L0,900
              Z
            "
          />
        </svg>
      </div>

      {/* ================= CONTENT ================= */}
      <motion.div
        initial={{ y: 50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.9, ease: "easeOut" }}
        viewport={{ once: true }}
        className="
          relative z-10
          mx-auto max-w-7xl
          px-6
          pt-46
          pb-14
          min-h-[520px]
          flex flex-col justify-end
        "
      >
        <div className="relative w-full">
          {/* LEFT CONTENT */}
          <div className="max-w-md">
            <h3 className="mb-4 text-3xl font-black">
              Pinak Dental Clinic
            </h3>
            <p className="py-2 text-slate-900 font-bold">
              The Right Choice for Your Dental Clinic Near Me
            </p>
            <p className="mb-6 text-slate-900 leading-relaxed">
Providing advanced, ethical dental care across Bengaluru with modern technology and experienced specialists at our RT Nagar clinic.            </p>

            {/* ===== SOCIAL ICONS ===== */}
            <div className="flex gap-4 mb-10">
              {[
                { Icon: FaFacebookF, href: "https://www.facebook.com/share/16gytK67oM/" },
                { Icon: FaInstagram, href: "https://www.instagram.com/pinakdentalclinicblr" },

              ].map(({ Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  className="
            h-12 w-12
            flex items-center justify-center
            rounded-full
            bg-black/25
            text-slate-900
            hover:bg-[#229653]
            transition
          "
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>

            <div className="border-t border-slate-900/20 pt-5 text-sm text-slate-900">
              © 2025 Pinak Dental Clinic. All rights reserved.
            </div>
          </div>

          {/* ===== DESIGNED BY ===== */}
          <div
            className="
      mt-6
      flex justify-center items-center gap-2
      text-slate-900/70

      md:absolute md:bottom-0 md:right-0
      md:mt-0
    "
          >
            <a
              href="https://www.mastermindweb.in"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:text-slate-900 transition"
            >
              <span className="tracking-wide text-sm">
                Designed by
              </span>

              <Image
                src="/mastermind.png"
                alt="Mastermind Web Developers"
                width={120}
                height={40}
                className="w-[110px] md:w-[120px] object-contain opacity-90 hover:opacity-100 transition"
              />
            </a>
          </div>
        </div>

      </motion.div>

      {/* ================= CHAIR (DESKTOP) ================= */}
      <div className="pointer-events-none absolute -top-20 md:-top-30 right-6 lg:right-20 z-10">
        <Image
          src="/chair.png"
          alt="Dental Chair"
          width={320}
          height={320}
          className="w-[260px] lg:w-[360px] xl:w-[420px]"
          priority
        />
      </div>

      {/* ================= CHAIR (MOBILE) ================= */}
      {/* <div className="md:hidden mt-12 flex justify-center pb-10">
        <Image
          src="/chair.png"
          alt="Dental Chair"
          width={220}
          height={220}
          className="opacity-95"
        />
      </div> */}

      {/* ================= DESIGNED BY ================= */}


    </footer>
  );
}
